import { isValueFunctionType } from '../../utils/common'

import {
  MediaRecorderState,
  MicrophonePermissionErrorName,
  MicrophonePermissionName,
  MicrophonePermissionState,
} from './useMicrophoneStream.constants'

export function isMicrophonePermissionError(error) {
  if (!error) {
    return false
  }

  return (
    error.name === MicrophonePermissionErrorName.NotAllowed ||
    error.name === MicrophonePermissionErrorName.PermissionDenied ||
    error.name === MicrophonePermissionErrorName.Security
  )
}

export function isMediaRecorderSupported(mimeType) {
  if (typeof MediaRecorder === 'undefined') {
    return false
  }

  return MediaRecorder.isTypeSupported(mimeType)
}

export function isMediaRecorderInactive(recorder) {
  return recorder.state === MediaRecorderState.Inactive
}

export function isMicrophonePermissionStateDenied(state) {
  return state === MicrophonePermissionState.Denied
}

export async function probeMicrophonePermission() {
  const permissionQuery = navigator.permissions?.query

  if (!isValueFunctionType(permissionQuery)) {
    return null
  }

  try {
    const permissionStatus = await permissionQuery.call(navigator.permissions, {
      name: MicrophonePermissionName,
    })

    return permissionStatus.state
  } catch {
    return null
  }
}
